import PayoutsChart from './PayoutsChart';

export default PayoutsChart;
